export const MEMBERSHIP_DOMAIN_QUERY = `
 query TravelHeader {
  membership(type: JWT_TOKEN) {
    demographics {
      firstName
      displayAccountNumber
      isTopCard
      product {
        productFamily
        cardArtCdnLink
        description
        isBasic
        productId
      }
    }
    accountToken
    loyalty {
      pointsBalance
      isPwpEligible
    } 
  }
}
`;
